// extracted by mini-css-extract-plugin
module.exports = {"textarea":"comment-form_textarea__GveIo","button":"comment-form_button__11j2M"};